// src/services/gameService.js
import websocketService from './websocketService';

class GameService {
  constructor() {
    this.listeners = {
      room: [],
      game: [],
      error: []
    };

    // 订阅 WebSocket 消息
    this.unsubscribe = websocketService.addListener(this.handleMessage.bind(this));
  }

  handleMessage(message) {
    const { event_type, room, game } = message;

    switch (event_type) {
      case 'room':
        this.notifyListeners('room', { action: room?.action, data: message });
        break;
      case 'game':
        this.notifyListeners('game', { action: game?.action, data: message });
        break;
      default:
        break;
    }
  }

  notifyListeners(type, data) {
    if (this.listeners[type]) {
      this.listeners[type].forEach(callback => callback(data));
    }
  }

  // 添加监听器
  addRoomListener(callback) {
    this.listeners.room.push(callback);
    return () => {
      this.listeners.room = this.listeners.room.filter(cb => cb !== callback);
    };
  }

  addGameListener(callback) {
    this.listeners.game.push(callback);
    return () => {
      this.listeners.game = this.listeners.game.filter(cb => cb !== callback);
    };
  }

  // ============ 房间操作 ============

  // 创建房间
  createRoom(nickname) {
    const message = {
      msg_id: this.generateMsgId(),
      event_type: 'room',
      timestamp: Date.now(),
      room: {
        action: 'room.create',
        data: {
          nickname: nickname
        }
      }
    };
    websocketService.sendMessage(message);
  }

  // 加入房间
  joinRoom(roomId, nickname) {
    const message = {
      msg_id: this.generateMsgId(),
      event_type: 'room',
      timestamp: Date.now(),
      room: {
        action: 'room.join',
        room_id: roomId,
        data: {
          nickname: nickname
        }
      }
    };
    websocketService.sendMessage(message);
  }

  // 离开房间
  leaveRoom() {
    const message = {
      msg_id: this.generateMsgId(),
      event_type: 'room',
      timestamp: Date.now(),
      room: {
        action: 'room.leave',
        data: {}
      }
    };
    websocketService.sendMessage(message);
  }

  // 准备/取消准备
  setReady(isReady) {
    const message = {
      msg_id: this.generateMsgId(),
      event_type: 'room',
      timestamp: Date.now(),
      room: {
        action: 'room.ready',
        data: {
          is_ready: isReady
        }
      }
    };
    websocketService.sendMessage(message);
  }

  // ============ 游戏操作 ============

  // 拿取一张货物卡
  takeOneCard(marketIndex) {
    const message = {
      msg_id: this.generateMsgId(),
      event_type: 'game',
      timestamp: Date.now(),
      game: {
        action: 'game.action.take_one_card',
        data: {
          market_index: marketIndex
        }
      }
    };
    websocketService.sendMessage(message);
  }

  // 拿取所有骆驼
  takeAllCamels() {
    const message = {
      msg_id: this.generateMsgId(),
      event_type: 'game',
      timestamp: Date.now(),
      game: {
        action: 'game.action.take_all_camels',
        data: {}
      }
    };
    websocketService.sendMessage(message);
  }

  // 交换货物
  exchangeCards(marketIndices, handCards, useCamels) {
    const message = {
      msg_id: this.generateMsgId(),
      event_type: 'game',
      timestamp: Date.now(),
      game: {
        action: 'game.action.exchange_cards',
        data: {
          market_indices: marketIndices,
          hand_cards: handCards,
          use_camels: useCamels
        }
      }
    };
    websocketService.sendMessage(message);
  }

  // 出售卡牌
  sellCards(cardType, count) {
    const message = {
      msg_id: this.generateMsgId(),
      event_type: 'game',
      timestamp: Date.now(),
      game: {
        action: 'game.action.sell_cards',
        data: {
          card_type: cardType,
          count: count
        }
      }
    };
    websocketService.sendMessage(message);
  }

  // ============ 工具方法 ============

  generateMsgId() {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }

  destroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
}

const gameService = new GameService();

export default gameService;
